export const SERVICE_CODE = 'DASHBOARD_CONSULTANT_PRODUCTION' + '_SERVICE';
